import axios from "axios";
import { getToken } from "./auth";
import { setupCache } from 'axios-cache-adapter'


// Create `axios-cache-adapter` instance
const cache = setupCache({
  maxAge: 15 * 60 * 1000
})
 
// Create `axios` instance passing the newly created `cache.adapter`
const api = axios.create({
  adapter: cache.adapter,
  baseURL: "https://apipos.faculdadeolgamettig.edu.br/api/"

})


api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.ContentType= 'application/x-www-form-urlencoded';
  }
  return config;
});

export default api;


// WEBPACK FOOTER //
// ./src/services/api.js